<template>
  <div>
    <div class="loginBg">
      <el-form :rules="rules" ref="loginForm"
               element-loading-text="正在登录"
               element-loading-spinner="el-icon-loading"
               element-loading-background="rgba(0, 0, 0, 0.8)"
               :model="loginForm"
               class="loginContainer">
        <h2 style="text-align: center;padding-bottom: 20px;">TallTalk登录</h2>
        <el-form-item prop="username">
          <el-input type="text" auto-complete="false" v-model="loginForm.username" placeholder="请输入用户名"></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input type="password" auto-complete="false" v-model="loginForm.password"
                    placeholder="请输入密码"></el-input>
        </el-form-item>
<!--        <el-form-item>-->
<!--          <el-checkbox v-model="checked">记住我</el-checkbox>-->
<!--        </el-form-item>-->
        <el-button type="primary" style="width: 100%" @click="submitLogin">登录</el-button>
        <el-form-item style="text-align: center; padding-bottom: 2px; margin: 0px 25px 0px 0px;color: #909399;">
          <div clas="copyright">©️TallTalk</div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data () {
    return {
      loginForm: {
        username: '',
        password: ''
      },
      checked: true,
      rules: {
        username: [{
          required: true,
          message: '请输入用户名',
          trigger: 'blur'
        }],
        password: [{
          required: true,
          message: '请输入密码',
          trigger: 'blur'
        }]
      }
    }
  },
  mounted () {
    // this.getCookie()
  },
  methods: {
    submitLogin () {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          // 判断复选框是否被勾选 勾选则调用配置cookie方法
          // if (this.checked) {
          //   // 传入账号名，密码，和保存天数3个参数
          //   this.clearCookie()
          //   this.setCookie(this.loginForm.username, this.loginForm.password, 30)
          // } else {
          //   // 清空Cookie
          //   this.clearCookie()
          // }
          this.postRequest('/login', this.loginForm).then(resp => {
            if (resp) {
              // 存储用户token
              const tokenStr = resp.obj.tokenHead + resp.obj.token
              window.sessionStorage.setItem('tokenStr', tokenStr)
              const path = this.$route.query.redirect
              // 页面跳转
              this.$router.replace((path === '/login' || path === undefined) ? '/home' : path)
            }
          })
        } else {
          this.$message.error('用户名或密码不能为空')
          return false
        }
      })
    }
    // // 设置cookie
    // setCookie (c_name, c_pwd, exdays) {
    // //  var exdate = new Date() //获取时间
    // //  exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays) // 保存的天数
    //   // 字符串拼接cookie
    //   window.document.cookie = 'username=' + c_name
    //   window.document.cookie = 'password=' + c_pwd
    // },
    // 读取cookie
    // getCookie: function () {
    //   if (document.cookie.length > 0) {
    //     console.log(document.cookie)
    //     const arr = document.cookie.split('; ') // 这里显示的格式需要切割一下自己可输出看下
    //     for (var i = 0; i < arr.length; i++) {
    //       var arr2 = arr[i].split('=') // 再次切割
    //       // 判断查找相对应的值
    //       if (arr2[0] === 'username') {
    //         this.loginForm.username = arr2[1] // 保存到保存数据的地方
    //         console.log(arr2[1])
    //       } else if (arr2[0] === 'password') {
    //         this.loginForm.password = arr2[1]
    //       }
    //     }
    //   }
    // },
    // // 清除cookie
    // clearCookie () {
    //   this.setCookie('', '', -1) // 修改2值都为空，天数为负1天就好了
    // }
  }
}
</script>

<style>
.loginContainer {
  border-radius: 15px;
  background-clip: padding-box;
  margin: 180px auto;
  width: 250px;
  padding: 15px 35px 15px 35px;
  background: #fff;
  border: 1px solid #eaeaea;
  box-shadow: 0 0 25px #cac6c6;
  position: relative;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}

.copyright {
  margin: 0px auto 40px auto;
  align-items: center;
  text-align: center;
  font-size: 13px;
}

.loginBg {
  /*background-image: url("../../assets/images/1.png");*/
  /*background-image: url("../../assets/images/quanjing.png");*/
  background-repeat: no-repeat;
  background-size: 100% 100%;
  height: 100%;
  width: 100%;
  position: fixed;
}
</style>
